/**
 * NOTE:
 *
 * Spacing should be consistent and whitespace thought of as a first class technique up
 * there with color and typefaces.
 *
 * To scale or shrink overall spacing, change @param baseSpacing value.
 *
 */
const baseSpacing = 10;

export default {
  tiny: baseSpacing * 0.4,
  small: baseSpacing * 0.8,
  medium: baseSpacing * 1.6,
  large: baseSpacing * 2.5,
  extraLarge: baseSpacing * 3.2
};
